import { __decorate } from "tslib";
import { Component, Vue, Ref } from 'vue-property-decorator';
import ControlLeft from '@blade-sxp/its-management/components/list/control-left.vue';
import ListTable from '@blade-sxp/its-management/components/list/list-table.vue';
import { getDevicesSummary } from '@blade-sxp/its-management/api/index';
import { isEmpty } from 'lodash';
let default_1 = class default_1 extends Vue {
    // 设备管理
    devicObj = {
        total: 0,
        online: 0,
        offline: 0,
        unknown: 0,
    };
    devicInfo = Object.assign({}, this.devicObj);
    // 左侧树
    treeRef;
    // table
    groupId = '';
    batchBtnIsShow = false;
    // 获取table上方的数据信息
    getDevicesSummary() {
        try {
            getDevicesSummary().then((res) => {
                // console.log(res);
                if (!isEmpty(res)) {
                    const { all, onlineDevice, offlineDevice, unknownDevice } = res;
                    this.devicInfo = Object.assign({}, {
                        total: all,
                        online: onlineDevice,
                        offline: offlineDevice,
                        unknown: unknownDevice,
                    });
                }
            });
        }
        catch (error) {
            console.log('getDevicesSummary err', error);
        }
    }
    mounted() {
        this.getDevicesSummary();
    }
    changeBatchBtnIsShow(val) {
        this.batchBtnIsShow = val;
    }
    getroupId(e) {
        this.groupId = e;
        this.getDevicesSummary();
    }
    // 收藏发生变化
    onLickChange() {
        this.$nextTick(() => {
            this.$refs.treeRef.getTreeData();
        });
    }
};
__decorate([
    Ref()
], default_1.prototype, "treeRef", void 0);
default_1 = __decorate([
    Component({
        name: 'passList',
        components: { ControlLeft, ListTable },
        i18n: {
            messages: {
                'en-us': {
                    bgdManagement: 'Background Management',
                    deviceManagement: 'Device Management',
                    total: 'Total',
                    online: 'Online',
                    offline: 'Offline',
                    unknown: 'Unknown',
                },
                zh: {
                    bgdManagement: '背景图管理',
                    deviceManagement: '设备管理',
                    total: '总数',
                    online: '在线',
                    offline: '离线',
                    unknown: '未知',
                },
            },
        },
    })
], default_1);
export default default_1;
